export default "__VITE_ASSET__DRLAe8_i__"